import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { eventBus } from "@/main";
import EventCenter from "@/utils/EventCenter";
import RechargeDialog from "@/components/RechargeDialog.vue";
import insufficientIllustration from "@/assets/images/marketingTools/team-balance-insufficient.svg";
import insufficientSpark from "@/assets/images/marketingTools/team-balance-insufficient-spark.svg";
import closeIcon from "@/assets/images/marketingTools/dialog-close-small.svg";
export default {
  __name: 'WhatsAppBalanceInsufficientDialog',
  setup(__props) {
    const visible = ref(false);
    const rechargeDialogVisible = ref(false);
    const socketPayload = ref({});

    // 后端可能将费用放在消息根节点或 data 中，读取两层可兼容已有 WebSocket 返回结构。
    const readSocketAmount = keys => {
      const payload = socketPayload.value || {};
      const candidates = [payload, payload.data].filter(item => item && typeof item === "object");
      for (const candidate of candidates) {
        for (const key of keys) {
          if (candidate[key] !== undefined && candidate[key] !== null && candidate[key] !== "") {
            return candidate[key];
          }
        }
      }
      return null;
    };

    // 金额仅负责展示，保留接口返回的小数位；异常或缺失的返回值不会转换为 0 以免误导用户。
    const formatAmount = value => {
      const rawAmount = String(value).trim();
      const amount = Number(rawAmount);
      if (!Number.isFinite(amount)) return "--";
      return `$${rawAmount}`;
    };

    // 50001 响应以 team_amount 表示当前余额；旧字段保留兼容，避免不同接口版本展示异常。
    const socketBalance = computed(() => readSocketAmount(["team_amount", "balance", "team_balance", "current_balance", "balance_available"]));
    const balance = computed(() => formatAmount(socketBalance.value));
    // 50001 响应以 frozen_amount 表示本次发送预估冻结金额，优先使用该字段。
    const estimatedCost = computed(() => formatAmount(readSocketAmount(["frozen_amount", "estimated_cost", "estimated_amount", "estimate_amount", "cost"])));
    // 充值组件只接收数值余额，异常载荷回退为 0，避免将展示格式字符串传入支付明细。
    const rechargeBalance = computed(() => {
      const amount = Number(socketBalance.value);
      return Number.isFinite(amount) ? amount : 0;
    });
    const openDialog = (payload = {}) => {
      // 每次 50001 响应都刷新金额；visible 复用同一个实例，避免多层遮罩叠加。
      socketPayload.value = payload;
      visible.value = true;
    };
    const closeDialog = () => {
      // 关闭时清理上一次会话金额，下一次消息仅展示自身携带的数据。
      visible.value = false;
      socketPayload.value = {};
    };
    const goToRecharge = () => {
      // 保留本次余额供支付明细使用，并将余额提示切换为同站的在线充值支付弹窗。
      visible.value = false;
      rechargeDialogVisible.value = true;
    };
    onMounted(() => {
      // WebSocket 业务组件通过全局事件触发，弹窗不依赖当前聊天会话的生命周期。
      eventBus.$on(EventCenter.openWhatsAppBalanceInsufficientDialog, openDialog);
    });
    onBeforeUnmount(() => {
      // 根组件销毁或热更新时解除监听，避免同一 50001 响应触发多次。
      eventBus.$off(EventCenter.openWhatsAppBalanceInsufficientDialog, openDialog);
    });
    return {
      __sfc: true,
      visible,
      rechargeDialogVisible,
      socketPayload,
      readSocketAmount,
      formatAmount,
      socketBalance,
      balance,
      estimatedCost,
      rechargeBalance,
      openDialog,
      closeDialog,
      goToRecharge,
      RechargeDialog,
      insufficientIllustration,
      insufficientSpark,
      closeIcon
    };
  }
};